module.exports = __webpack_public_path__ + "assets/img/9cc8-us.svg";